import { Language } from '../../../types/user/User'
import { fetchFormulas } from '../service/formulaService'
import { Formula } from '../types/Formula'
import formulaQueryKeys from './formulaQueryKeys'

export const getFormulaOptions = <TData = Formula[]>(
  companyId?: string,
  lng = Language.fi,
  select?: (data: Formula[], lng: Language) => TData
) => {
  return {
    queryKey: formulaQueryKeys.list({ companyId }),
    queryFn: fetchFormulas,
    gcTime: 15 * 60 * 1000,
    enabled: !!companyId,
    select: (data: Formula[]) => {
      const sortedData = data.slice().sort((a, b) => a.order - b.order)
      return select ? select(sortedData, lng) : (sortedData as TData)
    }
  }
}
